import { useEffect } from "react";

/**
 * Nested-safe body scroll lock. Multiple callers can lock at once;
 * overflow is restored only when the last lock releases.
 */
let lockCount = 0;
let previousOverflow = "";

export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    if (typeof document === "undefined") return undefined;

    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        document.body.style.overflow = previousOverflow;
      }
    };
  }, [locked]);
}

export default useBodyScrollLock;
